import filtersKeys from 'constants/filters';
import { FilterTypes } from 'constants/FilterTypes';
import modes from 'components/ui/buttonsGroup/modes';

export const etoPaymentsStatusConfig = {
    filterId: filtersKeys.paymentStatus,
    mode: modes.multi,
    list: [
        { id: 'success', text: 'statuses.success' },
        { id: 'decline', text: 'statuses.decline' },
        { id: 'refunded', text: 'statuses.refund' },
        { id: 'processing', text: 'statuses.processing' },
    ],
};